@if (href) {
  <a
    class="pressable"
    routerLinkActive="pressable--active"
    [ngClass]="'pressable--' + variant"
    [href]="href">
    <span class="pressable__inner">{{ label }}</span>
  </a>
} @else {
  <a
    class="pressable"
    routerLinkActive="pressable--active"
    [ngClass]="'pressable--' + variant"
    [routerLink]="routerLink">
    <span class="pressable__inner">{{ label }}</span></a
  >
}
